<section class="companion-section">
  <div class="companion-field-grid">
    <mat-form-field appearance="outline">
      <mat-label>Delay (seconds)</mat-label>
      <mat-select [formControl]="_formGroup.controls.delay">
        <mat-option *ngFor="let option of delayOptions" [value]="option">
          {{ option | number: "1.1-1" }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="showPromptControl">
      <mat-label>Prompt</mat-label>
      <mat-select [formControl]="_formGroup.controls.timerPrompt">
        <mat-option *ngFor="let option of promptOptions" [value]="option">
          {{ option === 0 ? "Solid" : (option | number: "1.1-1") }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</section>

<section class="companion-section">
  <h4 class="companion-section__title">Type</h4>
  <mat-tab-group
    class="custom-tab-group"
    [selectedIndex]="companionTypeTabIndex"
    (selectedTabChange)="onAgilityTabChange($event)"
  >
    <mat-tab label="Color">
      <ng-template matTabContent>
        <div class="flex flex-col gap-6 my-4">
          <div class="companion-color-picker">
            <h4 class="companion-section__title">React to</h4>
            <div class="companion-color-grid">
              <button
                type="button"
                class="react-option"
                *ngFor="let color of colorOptions; let i = index"
                [ngClass]="color.className"
                [class.full-opacity]="react[i]"
                [attr.aria-label]="'React to ' + color.name"
                [attr.aria-pressed]="react[i]"
                [title]="color.name"
                (click)="setReact(i, false)"
                matRipple
              >
                <i class="material-icons react-overlay-icon" *ngIf="react[i]">
                  done
                </i>
              </button>
            </div>
          </div>
          <div class="companion-color-picker">
            <h4 class="companion-section__title">Don't React to</h4>
            <div class="companion-color-grid">
              <button
                type="button"
                class="react-option"
                *ngFor="let color of colorOptions; let i = index"
                [ngClass]="color.className"
                [class.full-opacity]="dontReact[i]"
                [attr.aria-label]="'Do not react to ' + color.name"
                [attr.aria-pressed]="dontReact[i]"
                [title]="color.name"
                (click)="setReact(i, true)"
                matRipple
              >
                <i
                  class="material-icons react-overlay-icon"
                  *ngIf="dontReact[i]"
                >
                  done
                </i>
              </button>
            </div>
          </div>
        </div>
        <mat-error
          class="companion-error"
          *ngIf="_formGroup.touched && _formGroup.errors?.['minReactTo']"
        >
          Select at least one React color.
        </mat-error>
      </ng-template>
    </mat-tab>

    <mat-tab label="Number">
      <ng-template matTabContent>
        <section class="companion-section">
          <h4 class="companion-section__title">Number Type</h4>
          <mat-tab-group
            class="custom-tab-group"
            [selectedIndex]="numberType.value"
            (selectedTabChange)="onNumberTabChange($event)"
          >
            <mat-tab label="Single Value">
              <ng-template matTabContent>
                <div class="companion-field-grid my-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Count Increment By</mat-label>
                    <mat-select
                      [formControl]="_formGroup.controls.countIncrementBy"
                    >
                      <mat-option
                        *ngFor="let item of [].constructor(100); let i = index"
                        [value]="i + 1"
                      >
                        {{ i + 1 }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Count Direction</mat-label>
                    <mat-select
                      [formControl]="_formGroup.controls.countDirection"
                    >
                      <mat-option value="Ascending">Ascending</mat-option>
                      <mat-option value="Descending">Descending</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Limit Low</mat-label>
                    <input
                      matInput
                      type="number"
                      step="1"
                      min="1"
                      max="999"
                      [formControl]="_formGroup.controls.startValue"
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Limit High</mat-label>
                    <input
                      matInput
                      type="number"
                      step="1"
                      min="2"
                      max="999"
                      [formControl]="_formGroup.controls.endValue"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="companion-error"
                  *ngIf="
                    _formGroup.touched &&
                    _formGroup.errors?.['invalidNumberRange']
                  "
                >
                  Limit High must be greater than Limit Low, and both values
                  must be positive.
                </mat-error>
              </ng-template>
            </mat-tab>
            <mat-tab label="Math Formula">
              <ng-template matTabContent>
                <mat-form-field appearance="outline" class="w-full my-4">
                  <mat-label>Complexity Level</mat-label>
                  <mat-select
                    [formControl]="_formGroup.controls.complexityLevel"
                  >
                    <mat-option value="Beginner">Beginner</mat-option>
                    <mat-option value="Intermediate">Intermediate</mat-option>
                    <mat-option value="Advanced">Advanced</mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </section>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</section>
